import PropTypes from 'prop-types'

import { useIsReadOnly } from '@hooks/useIsReadOnly'

// Segmented Active/Inactive control — matches the Client Type segmented control
// in ClientForm. Controlled via `toggle`; clicking either button fires
// `handleToggleActive` with a synthetic event shaped { target: { name, value } }
// where value is 'active' | 'inactive' (preserves the legacy MUI contract that
// callers like ClientForm rely on).
export const ToggleActive = ({ toggle, handleToggleActive, disabled: disabledProp = false }) => {
  // Activating/deactivating is a write.
  const isReadOnly = useIsReadOnly()
  const disabled = disabledProp || isReadOnly
  const options = [
    { label: 'Active', value: 'active', isActive: toggle },
    { label: 'Inactive', value: 'inactive', isActive: !toggle }
  ]
  return (
    <>
      <div className='mb-2 text-[12px] font-semibold uppercase tracking-wide text-[#6B7280]'>Client Status</div>
      <div role='group' aria-label='status' className='mb-5 inline-flex rounded-md border border-[#D1D5D8] bg-white p-0.5'>
        {options.map((opt) => (
          <button
            key={opt.value}
            type='button'
            aria-pressed={opt.isActive}
            aria-label={opt.value}
            disabled={disabled}
            onClick={() => handleToggleActive({ target: { name: 'status', value: opt.value } })}
            className={`rounded px-5 py-1.5 text-[13px] font-bold uppercase tracking-wide transition-colors disabled:opacity-50 disabled:pointer-events-none ${
              opt.isActive ? 'bg-[#0A1628] text-white' : 'bg-transparent text-[#0A1628] hover:bg-[#F8FAFC]'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </>
  )
}

ToggleActive.propTypes = {
  toggle: PropTypes.bool.isRequired,
  handleToggleActive: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}
